import React from 'react';
import PropTypes from 'prop-types';

import NumberFormatInput from '../NumberFormatInput';
import FormikField from './FormikField';

const FormikNumberFormatInputField = ({ field, form, showNoError, ...other }) => (
  <FormikField field={field} form={form} showNoError={showNoError}>
    <NumberFormatInput
      onChange={({ target }) => {
        form.setFieldValue(field.name, target.value, true);
        form.setTouched({ [field.name]: true });
      }}
      {...other}
    />
  </FormikField>
);

FormikNumberFormatInputField.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.string,
  }).isRequired,
  form: PropTypes.shape({
    errors: PropTypes.object,
    touched: PropTypes.object,
    setFieldError: PropTypes.func,
    setFieldValue: PropTypes.func,
    setTouched: PropTypes.func,
  }).isRequired,
  showNoError: PropTypes.bool,
  other: PropTypes.object,
};

FormikNumberFormatInputField.defaultProps = {
  showNoError: false,
  other: null,
};

export default FormikNumberFormatInputField;
